








import { Component, Mixins } from 'vue-property-decorator'

import AuthMixin from '@/mixins/AuthMixin'
import { sharedInstance as authService } from '@/services/AuthService'

import 'firebaseui/dist/firebaseui.css'

@Component
export default class LoginComponent extends Mixins(AuthMixin)
{
	private email: string = ''
	private password: string = ''

	get isSignedIn()
	{
		return this.$store.getters['auth/signedIn']
	}

	mounted()
	{
		authService.signInWithUI('#firebase-auth-container')
	}
}
